import { Injectable, InjectionToken, Provider } from '@angular/core';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiInstitutionPerson, ApiUpdateInstitutionPerson } from '../api-types/institution.api';
import {
	transformApiInstitutionPersonNeighborsToAppInstitutionPersonNeighbors,
	transformApiInstitutionPersonsToAppInstitutionPersons,
	transformApiInstitutionPersonToAppInstitutionPerson,
	transformAppUpdateInstitutionPersonToApiUpdateInstitutionPerson,
} from '../transformers/instition.tranform';
import { BaseRequestService } from './base-request.service';
import { InstitutionPerson, UpdateInstitutionPerson } from '../app-types/institution.app';
import { NeighborContext } from '../app-types/neighbors.app';
import { ApiNeighborContext } from '../api-types/neighbor.api';

export const INSTITUTION_PERSON_SERVICE = new InjectionToken<InstitutionPersonService>('INSTITUTION_PERSON_SERVICE');

@Injectable()
export class InstitutionPersonService extends BaseRequestService {
	public async getAll(institutionId: number, offset?: number, range?: number) {
		const response = await this.get<PaginatedResponse<ApiInstitutionPerson>>(
			`institution/${institutionId}/institutionPerson`,
			{ offset, range },
		);
		const entities = transformApiInstitutionPersonsToAppInstitutionPersons(response.entities);
		return {
			...response,
			entities: entities,
		};
	}

	public async getById(institutionId: number, personId: number) {
		const response = await this.get<ApiInstitutionPerson>(`institution/${institutionId}/institutionPerson/${personId}`);
		return transformApiInstitutionPersonToAppInstitutionPerson(response);
	}

	public async deactivatePerson(institutionId: number, personId: number) {
		return await this.post<void, void>(`institution/${institutionId}/institutionPerson/${personId}`, undefined);
	}

	public async updatePerson(institutionId: number, personId: number, body: UpdateInstitutionPerson) {
		const payload = transformAppUpdateInstitutionPersonToApiUpdateInstitutionPerson(body);
		const response = this.put<InstitutionPerson, ApiUpdateInstitutionPerson>(
			`institution/${institutionId}/institutionPerson/${personId}`,
			payload,
		);
		return response;
	}

	public async getInstitutionPersonNeighbors(
		institutionId: number | string,
		personId: number | string,
	): Promise<NeighborContext<InstitutionPerson>> {
		const response = await this.get<ApiNeighborContext<ApiInstitutionPerson>>(
			`institution/${institutionId}/institutionPerson/${personId}/neighbors`,
		);
		return transformApiInstitutionPersonNeighborsToAppInstitutionPersonNeighbors(response);
	}
}

export const provideInstitutionPersonService: Provider = {
	provide: INSTITUTION_PERSON_SERVICE,
	useClass: InstitutionPersonService,
};
